import React from "react";
import { hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App'

const data = window.__SSR_DATA__ || [{},{}]
 

hydrateRoot( document.getElementById('root'),
     <HelmetProvider>
        <BrowserRouter basename="/news/">
            <App data={data} />
        </BrowserRouter>
     </HelmetProvider>
)